import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueJustifiedLayout from "vue-justified-layout";
import VueLazyload from "vue-lazyload";
import vueScrollBehavior from "vue-scroll-behavior";

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(VueJustifiedLayout);
Vue.use(VueLazyload);
// Using vueScrollBehavior
Vue.use(vueScrollBehavior, {
  router: router, // The router instance
  el: "#app", // Custom element
  maxLength: 100, // Saved history List max length
  ignore: [/\/about/], // ignore some routes, they will directly scroll to the top
  delay: 0 // Delay by a number of milliseconds
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
